import { useAppSelector } from "../../../../../../redux/hooks";
import CarFeaturedTile from "./carFeaturedTile";
import CarTile from "./carTile";
import { Car } from "../types";
import NoFilteredCars from "./noFilteredCars";
import InfiniteScroll from "react-infinite-scroll-component";
import { useEffect, useRef, useState } from "react";
import { CARS_PER_PAGE } from "../ourCars-constants";
import { hasActiveSubscription } from "../../../../../../../helpers/hasActiveSubscription";
import { getCarProps } from "../../../../../../../helpers/getCarProps";

const OurCarPrizes = ({
  isMobile,
  isActiveComp,
  isInstantWinActive,
}: {
  isMobile: boolean;
  isActiveComp: boolean;
  isInstantWinActive: boolean;
}) => {
  const carPrizes: Car[] = useAppSelector(state => state.cars.filteredList);
  const carsStartIndex = useRef(0);
  const carsEndIndex = useRef(CARS_PER_PAGE);
  const [carsInView, setCarsInView] = useState<Car[]>([]);
  useEffect(() => {
    const correctlyPositionedPrizes = getCorrectPositioningOfPrizes();
    carsStartIndex.current = 0;
    carsEndIndex.current = CARS_PER_PAGE;
    const carsToDisplay = correctlyPositionedPrizes.slice(carsStartIndex.current, carsEndIndex.current);
    setCarsInView([...carsToDisplay]);
  }, [carPrizes]);

  const reviveAdBanner = useRef();

  useEffect(() => {
    if (reviveAdBanner) {
      const reviveScript = document.createElement("script");
      reviveScript.src = "//www.botb.com/www/delivery/asyncjs.php";
      reviveScript.async = true;
      const adContainer = document.getElementById("script_ad_server");
      if (adContainer) {
        adContainer.appendChild(reviveScript);
      }
      return () => {
        if (adContainer) {
          adContainer.innerHTML = "";
        }
      };
    }
  }, [reviveAdBanner]);

  const generateFeaturedPrizeIndexes = (featuredPrizes: Car[]) => {
    const featuredPrizeIndexes = [];
    const intervals = [4, 8];
    let currentIndex = 6;
    for (let i = 0; i < featuredPrizes.length; i++) {
      featuredPrizeIndexes.push(currentIndex);
      currentIndex += intervals[i % intervals.length];
    }
    return featuredPrizeIndexes;
  };

  const getCorrectPositioningOfPrizes = () => {
    const nonFeaturedPrizes = carPrizes.filter(car => !car.IsFeatured);
    const featuredPrizes = carPrizes.filter(car => car.IsFeatured);
    const featuredPrizeIndexes = generateFeaturedPrizeIndexes(featuredPrizes);
    const result = [];
    if (nonFeaturedPrizes.length > 0) {
      for (let i = 0; i < nonFeaturedPrizes.length; i++) {
        if (featuredPrizeIndexes.includes(i)) {
          result.push(featuredPrizes.shift());
        }
        result.push(nonFeaturedPrizes[i]);
      }
    }
    for (let i = 0; i < featuredPrizes.length; i++) {
      result.push(featuredPrizes[i]);
    }
    return result;
  };

  const renderTile = (prize: Car) => {
    const props = getCarProps(prize);
    if (prize.IsFeatured && prize.FeaturedTileVideo !== null) {
      return <CarFeaturedTile videoSource={prize.FeaturedTileVideo} {...props} />;
    }
    return <CarTile {...props} isInstantWinActive={isInstantWinActive} />;
  };

  if (carPrizes.length === 0) {
    return <NoFilteredCars isMobile={isMobile} isActiveComp={isActiveComp} />;
  }

  const showCarPrizeDetails = (prizeUrl: string, contentNodeId: number) => {
    sessionStorage.setItem("prizeId", contentNodeId.toString());
    location.href = prizeUrl;
  };

  const fetchMoreCars = () => {
    carsStartIndex.current = carsStartIndex.current + CARS_PER_PAGE;
    carsEndIndex.current = carsEndIndex.current + CARS_PER_PAGE;
    const correctlyPositionedPrizes = getCorrectPositioningOfPrizes();
    const carsToDisplay = correctlyPositionedPrizes.slice(carsStartIndex.current, carsEndIndex.current);
    setCarsInView(loadedCars => [...loadedCars, ...carsToDisplay]);
  };

  return (
    <InfiniteScroll
      key={location.href}
      dataLength={carsInView.length}
      next={fetchMoreCars}
      hasMore={carsInView.length < carPrizes.length}
      loader=""
      style={{ overflowX: "hidden" }}
      scrollThreshold={0.5}>
      <div className="grid grid-flow-dense xs:grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 mt-4 xs:px-1 xs:gap-2 md:px-4 md:gap-4">
        <div id={"script_ad_server"} className={"hidden"} />
        <div ref={reviveAdBanner} className={"hidden"} />

        {carsInView.map((prize: Car, index: number) => {
          const items = [];

          items.push(
            <div
              key={`card-${prize.Make}-${prize.Model}-${index}`}
              className={`cursor-pointer ${prize.IsFeatured ? "col-span-2" : ""}`}
              onClick={() => showCarPrizeDetails(prize.Url, prize.ContentNodeId)}>
              {renderTile(prize)}
            </div>
          );

          if (index === 1) {
            items.push(
              <ins
                data-revive-usersubscriber={hasActiveSubscription()}
                key={`card-ad-banner-mobile`}
                data-revive-zoneid="3"
                data-revive-source="DC_card01_mob"
                data-revive-id="6ee315d200a003a5ac39b07d0dd34156"
                className={"lg:hidden [&_img]:size-full [&_img]:object-cover"}></ins>,
              <ins
                data-revive-usersubscriber={hasActiveSubscription()}
                key={`card-ad-banner-desktop`}
                data-revive-zoneid="4"
                data-revive-source="DC_card01_desk"
                data-revive-id="6ee315d200a003a5ac39b07d0dd34156"
                className={"max-lg:hidden [&_img]:size-full [&_img]:object-cover"}></ins>
            );
          }

          if (index === 5) {
            items.push(
              <ins
                data-revive-usersubscriber={hasActiveSubscription()}
                key={`wide-ad-banner-mobile`}
                data-revive-zoneid="5"
                data-revive-source="DC_card01_mob"
                data-revive-id="6ee315d200a003a5ac39b07d0dd34156"
                className={"lg:hidden col-span-2 md:col-span-3 [&_img]:size-full [&_img]:object-cover"}></ins>,
              <ins
                data-revive-usersubscriber={hasActiveSubscription()}
                key={`wide-ad-banner-desktop`}
                data-revive-zoneid="6"
                data-revive-source="DC_wide01_desk"
                data-revive-id="6ee315d200a003a5ac39b07d0dd34156"
                className={"max-lg:hidden lg:col-span-4 [&_img]:size-full [&_img]:object-cover"}></ins>
            );
          }

          return items;
        })}
      </div>
    </InfiniteScroll>
  );
};

export default OurCarPrizes;
